export default {"src":"https://webcdn.trailways.com/_next/static/media/package.3eb89096.svg","height":180,"width":180,"blurWidth":0,"blurHeight":0};